import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, unref as _unref, withCtx as _withCtx, createTextVNode as _createTextVNode, createSlots as _createSlots } from "vue"

import {
  withDefaults,
  ref,
  onMounted,
  computed
} from 'vue';
import {
  BaseDialog,
  BaseTextContent,
  BaseButton,
  XrkMessageBox,
  XrkMessage
} from 'xrk-components';
import {
  invoiceDetail,
  auditInvoice,
  saveInvoice,
  redInvoice,
  openReject
} from '@V/invoice/src/data-source/apis';
import {
  InvoiceDetailData,
  AuditInvoiceParams,
  InvoiceApplyDTO,
  InvoiceApplyDetailListDTO
} from '@V/invoice/src/data-source/types';
import { DetailType } from '@V/invoice/src/types';
import InvoiceDetailDialogInfo from './invoice-detail-dialog-info.vue';
import InvoiceDetailDialogAddress from './invoice-detail-dialog-address.vue';
import InvoiceDetailDialogDemand from './invoice-detail-dialog-demand.vue';
import InvoiceDetailDialogFile from './invoice-detail-dialog-file.vue';
import InvoiceDetailDialogAudit from './invoice-detail-dialog-audit.vue';
import { translator } from '@/utils';


export default /*#__PURE__*/_defineComponent({
  __name: 'invoice-detail-dialog',
  props: {
    id: {},
    detailType: { default: 1 },
    remove: {}
  },
  emits: ["success"],
  setup(__props: any, { emit: __emit }) {

const TITLE = {
  1: '发票详情',
  2: '发票上传',
  3: '发票上传',
  4: '发票补充',
  5: '发票补充',
  6: '发票上传',
  7: '红冲申请',
  10: '发票审核'
};

const props = __props;
const emits = __emit;

const infoRef = ref(null);
const blueRef = ref(null);
const redRef = ref(null);
const auditRef = ref(null);
const formData = ref<InvoiceDetailData & { _audit: AuditInvoiceParams }>({
  info: {
    id: 0,
    supplierId: 0,
    supplierName: '',
    aspId: 0,
    aspName: '',
    itemName: '',
    itemId: 0,
    invoiceStatus: 0,
    openAt: '',
    invoiceAmount: 0,
    createAt: '',
    invoiceTypeName: '',
    invoiceType: 0,
    invoiceTitle: '',
    invoicePhone: '',
    invoiceIdentifierNo: '',
    invoiceOpenBank: '',
    invoiceBankNo: '',
    invoiceEnterpriseAddress: '',
    isSupplement1: 0,
    isSupplement2: 0,
    receiptFullName: '',
    receiptPhone: '',
    receiptAddress: '',
    authAt: '',
    noPassReason: '',
    invoiceBusinessType: null,
    invoiceOrderNo: '',
    dkPeopleFinishSum: 0,
    dkPeopleTotalSum: 0,
    updateAt: '',
    platformServicesPrice: 0,
    personalScalePrice: 0,
    taskAt: '',
    invoiceMethod: 0,
    taxRate: 0,
    email: '',
    receiptAddressName: '',
    orderMixtureType: null,
    professionType: 0,
    theSeller: 0,
    theSellerName: '',
    demand: ''
  },
  detailListBlue: [
    {
      detail: {
        id: null,
        invoiceApplyId: null,
        isMail: null,
        companyCode: '',
        companyName: '',
        trackingNo: '',
        importType: null,
        remark: '',
        createAt: null,
        invoiceType: null
      },
      imgList: [],
      fileList: []
    }
  ],
  detailListRed: [
    {
      detail: {
        id: null,
        invoiceApplyId: null,
        isMail: null,
        companyCode: '',
        companyName: '',
        trackingNo: '',
        importType: null,
        remark: '',
        createAt: null,
        invoiceType: null
      },
      imgList: [],
      fileList: []
    }
  ],
  _audit: {
    invoiceApplyId: null,
    invoiceStatus: null,
    invoiceType: null,
    noPassReason: null
  }
});

// 是否个体
const isInvoiceBusinessType7 = computed(() => {
  return [7].includes(formData.value.info.invoiceBusinessType);
});
// 是否为红票补充
const isSupplementRed = computed(() => {
  return (
    [4, 5].includes(props.detailType) &&
    [6].includes(formData.value.info.invoiceStatus)
  );
});
// 是否为蓝票补充
const isSupplementBlue = computed(() => {
  return (
    [4, 5].includes(props.detailType) &&
    [2].includes(formData.value.info.invoiceStatus)
  );
});
// 是否展示审核内容
const showAudit = computed(() => {
  return (
    // 详情、审核
    [1, 10].includes(props.detailType) &&
    // 待审核与审核完成展示
    [1, 2, 3, 5, 6, 7].includes(formData.value.info.invoiceStatus)
  );
});
// 是否展示红票
const showRed = computed(() => {
  return (
    // 详情、审核并且有红票数据
    ([1, 10].includes(props.detailType) &&
      formData.value.detailListRed[0].detail.id) ||
    // 上传红票
    [3].includes(props.detailType) ||
    isSupplementRed.value
  );
});
// 是否展示蓝票
const showBlue = computed(() => {
  // 默认一直展示，只有补充红票情况下不展示
  return !isSupplementRed.value;
});
// 是否展示操作
const showBtns = computed(() => {
  return props.detailType !== 1;
});
// 是否展示销方驳回
const showOpenReject = computed(() => {
  return (
    showBtns.value &&
    [2, 3].includes(props.detailType) &&
    // 待上传才可销方驳回
    [0, 4].includes(formData.value.info.invoiceStatus)
  );
});
// 是否为补充发票
const isSupplement = computed(() => {
  return [4, 5].includes(props.detailType);
});
/**
 * @description: 根据info整合是蓝还是红
 * @param {InvoiceApplyDTO} info
 * @return {InvoiceFunction} 蓝票1 红票2
 */
const invoiceFunctionByStatus = (info: InvoiceApplyDTO) => {
  return [0, 1, 2, 3].includes(info.invoiceStatus) ? 1 : 2;
};

const onOpenReject = async () => {
  const data = await XrkMessageBox.prompt('请输驳回原因', '提示', {
    cancelButtonText: '取消',
    confirmButtonText: '确认',
    inputType: 'textarea',
    inputErrorMessage: '请输入1-200个字符',
    inputValidator(v) {
      const _v = v.trim();
      return _v.length > 0 && _v.length <= 200;
    }
  });
  await openReject({
    invoiceApplyId: formData.value.info.id,
    invoiceStatus: 0,
    invoiceType: invoiceFunctionByStatus(formData.value.info),
    noPassReason: data.value.trim()
  });
  XrkMessage.success('操作成功');
  emits('success');
  props.remove();
};
const onConfirm = async () => {
  // await Promise.all([blueRef.value.validate(), redRef.value.validate()]);
  const { detailType } = props;
  // 上传蓝红票与补充材料（蓝票）
  if ([2, 3, 4, 5].includes(detailType)) {
    // detailType对应导入类型，正常上传为0，补充1为1，补充2为2
    const DETAIL_IMPORT_MAP = {
      2: 0,
      3: 0,
      4: 1,
      5: 2
    };
    let invoiceSend: InvoiceApplyDetailListDTO = null;
    // 供应商上传蓝票校验 开票信息
    if ([2].includes(detailType)) {
      await infoRef.value.validate();
    }
    // 校验蓝票发票、补充内容
    if ([2].includes(detailType) || isSupplementBlue.value) {
      await blueRef.value.validate();
      invoiceSend = formData.value.detailListBlue[0];
    }
    // 校验红票发票、补充内容
    if ([3].includes(detailType) || isSupplementRed.value) {
      await redRef.value.validate();
      invoiceSend = formData.value.detailListRed[0];
    }
    const {
      imgList,
      fileList,
      detail: { isMail, companyCode, companyName, trackingNo, remark }
    } = invoiceSend;
    const invoiceApplyId = formData.value.info.id;
    const importType = DETAIL_IMPORT_MAP[detailType];
    const invoiceType = invoiceFunctionByStatus(formData.value.info);

    await saveInvoice({
      isMail,
      companyCode,
      companyName,
      trackingNo,
      remark,
      id: invoiceApplyId,
      invoiceApplyId,
      importType,
      invoiceType,
      // 该字段为供应商上传蓝红票时传入
      ...(formData.value.info.taskAt &&
        detailType === 2 && { taskAt: formData.value.info.taskAt }),
      createAt: formData.value.info.createAt
        ? new Date(formData.value.info.createAt).getTime()
        : Date.now(),
      imgList: imgList.map(item => {
        return {
          ...item,
          ...(item.invoiceAmount && {
            // 根据类型提交正/负数
            invoiceAmount: translator.yuan2fen(
              invoiceType === 2 ? -item.invoiceAmount : +item.invoiceAmount
            )
          }),
          invoiceApplyId,
          importType,
          invoiceType
        };
      }),
      fileList: fileList.map(item => {
        return {
          ...item,
          fileName: item.name,
          fileUrl: item.url,
          createAt: item.createAt || Date.now(),
          invoiceApplyId,
          importType,
          invoiceType
        };
      })
    });
  }
  // 发起红票申请
  if (detailType === 7) {
    const data = await XrkMessageBox.prompt('请输入红冲原因', '提示', {
      cancelButtonText: '取消',
      confirmButtonText: '确认',
      inputType: 'textarea',
      inputErrorMessage: '请输入1-200个字符',
      inputValidator(v) {
        const _v = v.trim();
        return _v.length > 0 && _v.length <= 200;
      }
    });
    await redInvoice({ invoiceApplyId: props.id, reason: data.value.trim() });
  }
  // 审核
  if (detailType === 10) {
    await auditRef.value.validate();
    await auditInvoice(formData.value._audit);
  }
  XrkMessage.success('操作成功');
  emits('success');
  props.remove();
};
onMounted(async () => {
  // 格式化红票、蓝票数组
  const detailListFormat = detailList => {
    detailList?.forEach(item => {
      // invoiceAmount转为元，方便组件内使用，在提交处统一转为分。并且可能为负数，为负数时按正数处理，最终提交时候按类型给负数
      item?.imgList?.forEach(it => {
        it.invoiceAmount = translator.fen2yuan(Math.abs(it.invoiceAmount));
      });
      // 对应上传组件字段
      item?.fileList?.forEach(fl => {
        Object.assign(fl, {
          name: fl.fileName,
          url: fl.fileUrl,
          uid: fl.id
        });
      });
    });
    return detailList;
  };

  const { data } = await invoiceDetail({
    id: props.id,
    // 仅返回补充1数据，该情况对应的detailList只会为一个空数组
    ...([4].includes(props.detailType) && {
      importType: 1
    }),
    // 仅返回补充2数据，该情况对应的detailList只会为一个空数组
    ...([5].includes(props.detailType) && {
      importType: 2
    })
  });
  const { info, detailListRed, detailListBlue } = data;
  formData.value = {
    ...formData.value,
    info,
    ...(detailListRed.length && {
      detailListRed: detailListFormat(detailListRed)
    }),
    ...(detailListBlue.length && {
      detailListBlue: detailListFormat(detailListBlue)
    }),
    _audit: {
      invoiceApplyId: props.id,
      invoiceStatus: [2, 6].includes(info.invoiceStatus)
        ? 1 // 转换为通过状态
        : [3, 7].includes(info.invoiceStatus)
        ? 0 // 转换为驳回状态
        : null, // 默认状态
      invoiceType: invoiceFunctionByStatus(info),
      noPassReason: props.detailType === 10 ? '' : info.noPassReason // 审核进入后不展示上次驳回原因
    }
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseDialog), {
    width: "950px",
    class: "form-dialog form-dialog--label120 form-dialog-invoice-custom",
    title: TITLE[_ctx.detailType],
    "model-value": true,
    "close-on-press-escape": true,
    "close-on-click-modal": false,
    showFooter: false
  }, _createSlots({
    default: _withCtx(() => [
      _createVNode(_unref(BaseTextContent), null, {
        default: _withCtx(() => [
          (!isSupplement.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(InvoiceDetailDialogInfo, {
                  ref_key: "infoRef",
                  ref: infoRef,
                  detailType: _ctx.detailType,
                  "invoice-business-type": formData.value.info.invoiceBusinessType,
                  modelValue: formData.value.info,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.info) = $event))
                }, null, 8, ["detailType", "invoice-business-type", "modelValue"]),
                (!isInvoiceBusinessType7.value)
                  ? (_openBlock(), _createBlock(InvoiceDetailDialogAddress, {
                      key: 0,
                      modelValue: formData.value.info,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.info) = $event))
                    }, null, 8, ["modelValue"]))
                  : _createCommentVNode("", true),
                _createVNode(InvoiceDetailDialogDemand, {
                  modelValue: formData.value.info,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.info) = $event))
                }, null, 8, ["modelValue"])
              ], 64))
            : _createCommentVNode("", true),
          (showBlue.value)
            ? (_openBlock(), _createBlock(InvoiceDetailDialogFile, {
                key: 1,
                ref_key: "blueRef",
                ref: blueRef,
                invoiceFunction: 1,
                detailType: _ctx.detailType,
                id: _ctx.id,
                "invoice-business-type": formData.value.info.invoiceBusinessType,
                modelValue: formData.value.detailListBlue[0],
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.detailListBlue[0]) = $event))
              }, null, 8, ["detailType", "id", "invoice-business-type", "modelValue"]))
            : _createCommentVNode("", true),
          (!isSupplement.value)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(formData.value.detailListBlue, (item, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                  index
                    ? (_openBlock(), _createBlock(InvoiceDetailDialogFile, {
                        key: 0,
                        importType: index,
                        invoiceFunction: 1,
                        detailType: 1,
                        id: _ctx.id,
                        "invoice-business-type": formData.value.info.invoiceBusinessType,
                        modelValue: formData.value.detailListBlue[index],
                        "onUpdate:modelValue": ($event: any) => ((formData.value.detailListBlue[index]) = $event)
                      }, null, 8, ["importType", "id", "invoice-business-type", "modelValue", "onUpdate:modelValue"]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            : _createCommentVNode("", true),
          (showRed.value)
            ? (_openBlock(), _createBlock(InvoiceDetailDialogFile, {
                key: 3,
                ref_key: "redRef",
                ref: redRef,
                invoiceFunction: 2,
                detailType: _ctx.detailType,
                id: _ctx.id,
                "invoice-business-type": formData.value.info.invoiceBusinessType,
                modelValue: formData.value.detailListRed[0],
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.detailListRed[0]) = $event))
              }, null, 8, ["detailType", "id", "invoice-business-type", "modelValue"]))
            : _createCommentVNode("", true),
          (!isSupplement.value)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 4 }, _renderList(formData.value.detailListRed, (item, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                  index
                    ? (_openBlock(), _createBlock(InvoiceDetailDialogFile, {
                        key: 0,
                        importType: index + formData.value.detailListBlue.length - 1,
                        invoiceFunction: 2,
                        detailType: 1,
                        id: _ctx.id,
                        "invoice-business-type": formData.value.info.invoiceBusinessType,
                        modelValue: formData.value.detailListRed[index],
                        "onUpdate:modelValue": ($event: any) => ((formData.value.detailListRed[index]) = $event)
                      }, null, 8, ["importType", "id", "invoice-business-type", "modelValue", "onUpdate:modelValue"]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            : _createCommentVNode("", true),
          (showAudit.value)
            ? (_openBlock(), _createBlock(InvoiceDetailDialogAudit, {
                key: 5,
                ref_key: "auditRef",
                ref: auditRef,
                detailType: _ctx.detailType,
                invoiceFunction: invoiceFunctionByStatus(formData.value.info),
                modelValue: formData.value._audit,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value._audit) = $event))
              }, null, 8, ["detailType", "invoiceFunction", "modelValue"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 2
  }, [
    (showBtns.value)
      ? {
          name: "footer",
          fn: _withCtx(() => [
            _createVNode(_unref(BaseButton), {
              type: "default",
              onClick: _ctx.remove
            }, {
              default: _withCtx(() => [
                _createTextVNode("取消")
              ]),
              _: 1
            }, 8, ["onClick"]),
            (showOpenReject.value)
              ? (_openBlock(), _createBlock(_unref(BaseButton), {
                  key: 0,
                  type: "warning",
                  click: onOpenReject
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 驳回 ")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_unref(BaseButton), { click: onConfirm }, {
              default: _withCtx(() => [
                _createTextVNode("提交")
              ]),
              _: 1
            })
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["title"]))
}
}

})